import { useContext, useState } from "react";
import { OptionsContext } from "../store/params.js";
import { cleanStorageByPlaylist, handlePlayloop, updateStorage, getStorage } from "../data/storageManagement.js";
// import arraygex from "../data/regex";
import Player from "./player.js";
import Playlist from "./playlist";
import Wheel from '../assets/icons/wheel';
import { styleWheel } from './styleMain';
import SongList from './songlist';

import SpeechRecognition, {
  useSpeechRecognition,
  resetTranscript,
} from "react-speech-recognition";
import Modal from './modal';


import m4v from "../src/blank.m4v";
import ogv from "../src/blank.ogv";
import webm from "../src/blank.webm";

function Main() {
  const { playlists, params, setParams, getOneSongUnplayed, resetAudioListStatus, name, setName } = useContext(OptionsContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [micro, setMicro] = useState(true);
  const [messageModal, setMessageModal] = useState('');

  const { transcript, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

  const changeListening = () => {
    setMicro((micro) => !micro);
    if (micro) {
      SpeechRecognition.stopListening();
    } else {
      SpeechRecognition.startListening();
    }
  };

  const cleanPlaylist = (playlist) => {
    setIsModalOpen(true);
    setMessageModal(<SongList songs={playlist.audioLists} />);
  }

  const onChangeAudioList = (playlist) => {
    handlePlayloop("stop");
    // Amorcer le stockage AVANT de le lire : à la première visite la clé de la
    // playlist n'existe pas encore, et audioListStatus partirait à undefined.
    updateStorage(playlists);
    const allStorage = getStorage();
    // console.log('params in onchangeList', allStorage[playlist.name]);
    const accuratePlayList = allStorage[playlist.name];
    const newId = getOneSongUnplayed(playlist.name);
    const newParam = { indexplay: newId, audioLists: playlist.songs, audioListStatus: accuratePlayList };
    setName(playlist.name);
    setParams((prev) => ({ ...prev, ...newParam }));
  };

  const refreshData = () => {
    if (name) {
      cleanStorageByPlaylist(name);
      resetAudioListStatus();
    }
  }

  return (
    <div className="App">

      <div className="music-player">
        <div className="wheel" onClick={() => cleanPlaylist(params)} style={styleWheel}><Wheel /></div>
        <Player openSettings={() => cleanPlaylist(params)} />
      </div>

      <div className="bandana">
        <div
          onClick={changeListening}
          className={micro ? "ear earOn" : "ear earOff"}
        />
        <video controls loop>
          <source src={m4v} type="video/m4v" />
          <source src={ogv} type="video/ogg" />
          <source src={webm} type="video/webm" />
        </video>
      </div>

      <nav>
        {playlists.map((playlist, index) => (
          <div
            key={index}
            className={`button${params.audioLists === playlist.songs ? " active" : ""}`}
            onClick={() => onChangeAudioList(playlist)}
          >
            Playliste {playlist.name} ({playlist.songs.length})
          </div>
        ))}
        <span onClick={refreshData} className="reinit" />

      </nav>

      <div className="playlist">
        <Playlist />
      </div>

      {!browserSupportsSpeechRecognition ? (
        <span>Browser doesn't support speech recognition.</span>
      ) : (
        <div>
          <p className="transcript">{transcript}</p>
        </div>
      )}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Maintenance de {name}</h2>
        {messageModal}
      </Modal>
    </div>
  );
}

export default Main;
